
import React from 'react';
import { format } from 'date-fns';
import { TimelineMarker } from './types/insights';


interface TimelineTickMarkProps {
  marker: TimelineMarker;
  x: number;
  onClick: (marker: TimelineMarker) => void;
}

export const TimelineTickMark: React.FC<TimelineTickMarkProps> = ({ marker, x, onClick }) => {
  
  // Safety check for invalid marker data
  if (!marker || !marker.type || !marker.date) {
    return null;
  }
  
  const handleClick = () => {
    try {
      onClick(marker);
    } catch (err) {
      console.error('Error in timeline tick click handler:', err);
    }
  };
  
  const formatDate = (date: Date) => {
    try {
      return format(date, 'MMM d');
    } catch (err) {
      console.error('Error formatting date:', err, date);
      return 'Invalid date';
    }
  };

  // Determine marker color and hover color based on marker type
  let backgroundColor = '';
  let hoverColor = '';
  let tooltipText = '';
  
  switch(marker.type) {
    case 'insight':
      backgroundColor = 'bg-green-500';
      hoverColor = 'hover:bg-green-600';
      tooltipText = ` - Training Insight`;
      break;
    case 'session':
      backgroundColor = 'bg-blue-500';
      hoverColor = 'hover:bg-blue-600';
      tooltipText = ` - Training Session`;
      break;
    case 'both':
      backgroundColor = 'bg-purple-500';
      hoverColor = 'hover:bg-purple-600';
      tooltipText = ` - Session & Insight`;
      break;
    default:
      backgroundColor = 'bg-[#9b87f5]';
      hoverColor = 'hover:bg-primary';
      tooltipText = '';
  }

  // Use 4px width for both mobile and desktop
  const tickWidth = '4px';

  return (
    <div
      className="absolute top-1/2 transform -translate-y-1/2 pointer-events-auto group z-[40] touch-none"
      style={{ left: `${x}px` }}
    >
      <div
        onClick={handleClick}
        className={`h-8 pointer-events-auto transition-colors duration-200 ${backgroundColor} ${hoverColor} tick-mark-element`}
        style={{ width: tickWidth }}
      >
        <div className="absolute left-1/2 top-10 -translate-x-1/2 bg-secondary text-secondary-foreground text-[0.6rem] font-medium px-1.5 py-0.5 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
          {formatDate(marker.date)}
          {tooltipText}
        </div>
      </div>
    </div>
  );
};
